export async function canvasToImage(
  canvas: HTMLCanvasElement,
  mimeType = 'image/png',
  quality = 1
): Promise<Blob | undefined> {
  if (canvas) {
    try {
      const blob = await new Promise<Blob | null>((resolve) => {
        canvas.toBlob((b) => resolve(b), mimeType, quality);
      });

      return blob || undefined;
    } catch (e) {
      console.log(e instanceof Error ? e.message : e);
    }
  }

  return undefined;
}
